var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":"","text-center":""}},[_c('v-img',{attrs:{"contain":"","src":require("../../assets/sidelogo.png")}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }